'use client'

import clsx from 'clsx'

import { Text } from '@wartek-id/text'

import { Container } from '@/components/Container'

export const YayasanDefinitionCollapse = ({ className = '' }) => {
  return (
    <div className={clsx('bg-gray-5', className)}>
      <Container className="space-y-4 p-4">
        <div>
          <Text variant="heading-sm" className="mb-2">
            Definisi Yayasan Pendidikan
          </Text>
          <Text color="subdued">
            Yayasan pendidikan adalah yayasan yang menyelenggarakan pendidikan
            baik formal maupun nonformal.
          </Text>
        </div>
      </Container>
    </div>
  )
}
